module.exports = __webpack_public_path__ + "img/explanation.86f1bfff.svg";